import { render, staticRenderFns } from "./DirectingSectorForm.vue?vue&type=template&id=2b024598&"
import script from "./DirectingSectorForm.vue?vue&type=script&lang=js&"
export * from "./DirectingSectorForm.vue?vue&type=script&lang=js&"
import style0 from "./DirectingSectorForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports